import todoApp from "../assets/todo-app.png";
import reactMeals from "../assets/reactmeals.png";
import houzez from "../assets/houzez.png";
import bankist from "../assets/bankist.png";
import pizza from "../assets/pizzaAPp.png";
import piggame from "../assets/pigGame.png";

export const projectsData = [
  {
    title: "Houzez Real Estate",
    screenshot: houzez,
    tools: ["HTML,", "CSS,", "JavaScript,", "React.js"],
    githubLink: `https://github.com/vTanchev/Houzez-Real-Estate-React`,
    linkDemo: "https://houzez-real-estate-react.netlify.app/",
  },
  {
    title: "Pizza App",
    screenshot: pizza,
    tools: ["HTML,", "CSS,", "JavaScript,", "React.js"],
    githubLink: `https://github.com/vTanchev/PizzaAPP-React`,
    linkDemo:
      "https://64407d0c024dce031e611cfb--gentle-begonia-bae18d.netlify.app/",
  },
  {
    title: "Meal Application",
    screenshot: reactMeals,
    tools: ["HTML,", "CSS,", "JavaScript,", "React.js"],
    githubLink: `https://github.com/vTanchev/React-Meals`,
    linkDemo: "https://snazzy-bunny-4e669c.netlify.app/",
  },
  {
    title: "Todo Application",
    screenshot: todoApp,
    tools: ["HTML,", "CSS,", "JavaScript,", "React.js"],
    githubLink: `https://github.com/vTanchev/TODO-APP`,
    linkDemo: "https://todoapp-vaskotanchev.netlify.app/",
  },
  {
    title: "Bankist",
    screenshot: bankist,
    tools: ["HTML,", "CSS,", "JavaScript"],
    githubLink: `https://github.com/vTanchev/Bankist`,
    linkDemo: "https://stately-lolly-3a6e41.netlify.app/",
  },
  {
    title: "Pig Game",
    screenshot: piggame,
    tools: ["HTML,", "CSS,", "JavaScript"],
    githubLink: `https://github.com/vTanchev/Pig-Game`,
    linkDemo: "https://willowy-centaur-f58ef6.netlify.app/",
  },
];
